"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("core-js/fn/object/values");
require("core-js/fn/array/includes");
var common_1 = require("../common");
function validatePresence(name, value) {
    if (value == null) {
        throw new Error("\"" + name + "\" param is required");
    }
    if (Array.isArray(value) && value.length === 0) {
        throw new Error("\"" + name + "\" param can not be empty");
    }
    if (String(value).trim().length < 1) {
        throw new Error("\"" + name + "\" param can not be an empty or only-whitespace string");
    }
}
exports.validatePresence = validatePresence;
function validateList(_a) {
    var filters = _a.filters, sort = _a.sort;
    if (Boolean(filters))
        validateFilters(filters);
    if (Boolean(sort))
        validateSortings(sort);
}
exports.validateList = validateList;
function validateFilters(filters) {
    filters.forEach(function (filter) {
        validatePresence('filter.name', filter.name);
        validatePresence('filter.type', filter.type);
    });
}
exports.validateFilters = validateFilters;
function validateSortings(sortings) {
    sortings.forEach(function (sort) {
        validatePresence('sort.field', sort.field);
        validatePresence('sort.order', sort.order);
        if (!Object.values(common_1.SortingOrder).includes(sort.order)) {
            throw new Error('"sort.order" param should be either "asc" or "desc"');
        }
    });
}
exports.validateSortings = validateSortings;
function validateLineItems(items) {
    if (items == null) {
        throw new Error('"line_items" param is required');
    }
    items.forEach(function (item) {
        validatePresence('line_items[].item_id', item.item_id);
        validatePresence('line_items[].unit_price', item.unit_price);
        validatePresence('line_items[].quantity', item.quantity);
    });
}
exports.validateLineItems = validateLineItems;
//# sourceMappingURL=common.js.map